import type { FunctionComponent, ReactElement } from 'react';
import { useCallback, useMemo } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { headerActions } from '../../../store/slices/header/slice';
import { HeaderModal } from '../../../store/slices/header/types';
import { toastActions } from '../../../store/slices/toast/slice';
import { useIsLargerThanWide } from '../../../styles/hooks/media';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import { NavPages } from '../../nav/navPages/NavPagesConnected';
import { Toast } from '../Toast';
import type { ToastConnectedProps } from '../types';

export const AutomatedMessageToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();
  const isWideScreen = useIsLargerThanWide();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  const onBtnClick = useCallback((): void => {
    if (isWideScreen) {
      dispatch(headerActions.setOpenedModal(HeaderModal.Support));
    } else {
      dispatch(headerActions.setNavRoute([NavPages.HOME, NavPages.SUPPORT]));
    }

    closeFn();
  }, [dispatch, isWideScreen, closeFn]);

  const button = useMemo(
    () => ({
      tk: 'TOAST_MORE',
      onClick: onBtnClick,
    }),
    [onBtnClick]
  );

  return (
    <Toast
      button={button}
      icon={<Icon icon={Icons.Support} />}
      message={message}
      onClose={closeFn}
      duration={15000}
      {...rest}
    />
  );
};
